import Entity from './entity'

export default class Discuss extends Entity<string>{
    //评论内容
    comments: string;
    // 文章或资源Id
    targetId: string;
    // 分类类型（1文章，2资源,7课程管理，8每日一题）
    classTypeId: number;
    isAudited: boolean;
}